import React, { ReactElement, useMemo, useState } from "react";
import Select from "react-select";
import { ProjectTaskService } from ".";
import { IJsonObject } from "../api";
import { Loading } from "../ui";
import { ProjectTaskLabel } from "./ProjectTaskLabel";

interface IProps {
	handleChange: (selectedLabels: any[], actionType: any) => any;
	value?: any;
	defaultValue?: any;
}

export const ProjectTaskLabelsSelect = (props: IProps): ReactElement => {
	const [labels, setLabels] = useState<ProjectTaskLabel[]>();

	const taskService = new ProjectTaskService();

	useMemo(() => {
		const fetchLabels = async () => {
			const labelData = await taskService.findLabels();
			setLabels(labelData);
		};

		fetchLabels();
	}, []);

	if (!labels) {
		return <Loading />;
	}

	if (!labels.length) {
		return <span>No labels available</span>;
	}

	const options = labels.map((label: ProjectTaskLabel) => {
		return {
			value: label.id,
			label: label.name,
		};
	});

	const mapToLabels = (selected: any): ProjectTaskLabel[] => {
		const mapped = selected.map((select: IJsonObject) => {
			return labels.filter(
				(label: ProjectTaskLabel) => label.id === select.value,
			)[0];
		});

		return mapped;
	};

	return (
		<Select
			{...props}
			options={options}
			isMulti={true}
			isClearable={false}
			onChange={(selectedLabels: any, actionType: any) => {
				props.handleChange(mapToLabels(selectedLabels), actionType);
			}}
		/>
	);
};
